import { useRef, useState } from "react";
import "./ClickIcon.scss";

import { ReactComponent as dots } from "../../../../assets/icons/dots.svg";

import AcedMenu, { AcedMenuOption } from "../../menu/AcedMenu";
import AcedTooltip from "../../tooltip/AcedTooltip";

const icons = {
  dots,
};

export interface ClickIconProps {
  icon: keyof typeof icons;
  tooltip?: string;
  size?: "s" | "m" | "l" | number;
  options: AcedMenuOption[];
  isMenuOpen?: boolean;
  setMenuOpen?: (open: boolean) => void;
  onClose?: () => void;
}

const ClickIconMenu: React.FC<ClickIconProps> = ({
  icon,
  tooltip,
  size,
  options,
  isMenuOpen: controlledIsMenuOpen,
  setMenuOpen: controlledSetMenuOpen,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  // Internal state only if controlled props are not provided
  const [internalIsMenuOpen, internalSetMenuOpen] = useState(false);

  // Determine if component is controlled or uncontrolled
  const isControlled =
    controlledIsMenuOpen !== undefined && controlledSetMenuOpen !== undefined;

  // Use controlled state if available, else internal state
  const isMenuOpen = isControlled ? controlledIsMenuOpen : internalIsMenuOpen;
  const setMenuOpen = isControlled
    ? controlledSetMenuOpen
    : internalSetMenuOpen;

  const Icon = icons[icon];
  if (!Icon) return null;

  const colorStyle = {
    "--icon-color": "white",
  } as React.CSSProperties;

  const main = () => (
    <>
      <div
        ref={ref}
        onClick={() => {
          setMenuOpen(true);
        }}
        className={`icon-button icon-button-active`}
      >
        <Icon style={colorStyle} className={`icon-icon icon-active`} />
      </div>
      {isMenuOpen && (
        <AcedMenu
          anchorRef={ref}
          isMenuOpen={isMenuOpen}
          setMenuOpen={setMenuOpen}
          options={options}
          onClose={onClose}
        />
      )}
    </>
  );

  return tooltip && !isMenuOpen ? (
    <AcedTooltip text={tooltip}>{main()}</AcedTooltip>
  ) : (
    <>{main()}</>
  );
};

export default ClickIconMenu;
